import { avatarColor, initials } from "../lib/design";

interface Props {
  name: string;
  size?: number;
}

export function Avatar({ name, size = 20 }: Props) {
  return (
    <span
      className="avatar"
      title={name}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        background: avatarColor(name),
      }}
    >
      {initials(name)}
    </span>
  );
}
